var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordhide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7C14.8 7 17 9.2 17 12C17 12.2 17 12.5 16.9 12.7L19.9 15.7C20.7 14.7 21.3 13.6 21.9 12.4C22 12.1 22 11.9 21.9 11.6C19.9 6.9 16.1 4 12 4C10.9 4 9.8 4.2 8.8 4.6L11.3 7.1C11.5 7 11.8 7 12 7ZM21.7 20.3L18.6 17.2L16.1 14.8L14.6 13.3L10.6 9.3L9.2 7.8L7 5.5L3.7 2.3C3.3 1.9 2.7 1.9 2.3 2.3C1.9 2.7 1.9 3.3 2.3 3.7L5.4 6.8C4 8.2 2.9 9.8 2.1 11.6C2 11.9 2 12.1 2.1 12.4C4.1 17.1 7.9 20 12 20C13.8 20 15.5 19.4 17 18.4L20.3 21.7C20.7 22.1 21.3 22.1 21.7 21.7C22.1 21.3 22.1 20.7 21.7 20.3ZM12 17C9.2 17 7 14.8 7 12C7 11 7.3 10.1 7.8 9.3L9.3 10.8C9.1 11.1 9 11.6 9 12C9 13.7 10.3 15 12 15C12.4 15 12.9 14.9 13.3 14.7L14.8 16.2C13.9 16.7 13 17 12 17Z",
    fill: "#BCBCBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordhide);
export default __webpack_public_path__ + "static/media/passwordhide.573ea6970448d16cf5a90e30c17b5ad2.svg";
export { ForwardRef as ReactComponent };